// extracted by mini-css-extract-plugin
module.exports = {"tableElem":"tableElem__3ubwk","table":"table__34EcH"};